import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errorText, imgSrc } from "../../lib/api";

export const GalleryUpload = ({ value = [], onChange }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    const urls = [];
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await adminApi.post("/admin/upload", fd);
        urls.push(data.url);
      } catch (err) {
        toast.error(`${file.name}: ${errorText(err)}`);
      }
    }
    onChange([...value, ...urls]);
    if (urls.length) toast.success(`${urls.length} photo${urls.length > 1 ? "s" : ""} added`);
    setBusy(false);
  };

  return (
    <div data-testid="cf-gallery">
      <p className="mb-1 text-sm text-zinc-300">Photo gallery (shown on the event page — great for past shows)</p>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-5">
        {value.map((src, i) => (
          <div key={src + i} className="relative aspect-square overflow-hidden rounded-lg bg-[#0B0C10]" data-testid={`cf-gallery-item-${i}`}>
            <img src={imgSrc(src)} alt="" className="h-full w-full object-cover" />
            <button type="button" aria-label="Remove photo" data-testid={`cf-gallery-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute right-1 top-1 grid h-7 w-7 place-items-center rounded-full bg-black/70 text-white hover:bg-red-500"><X size={14} /></button>
          </div>
        ))}
        <button type="button" data-testid="cf-gallery-add" disabled={busy} onClick={() => ref.current?.click()} className="grid aspect-square place-items-center rounded-lg border border-dashed border-white/20 text-zinc-300 hover:border-[#FF5A1E] hover:text-white">
          {busy ? <Loader2 className="animate-spin" /> : <ImagePlus />}
        </button>
      </div>
      <input ref={ref} data-testid="cf-gallery-input" type="file" multiple accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={pick} />
    </div>
  );
};
